<template>
  <div class="tickets">
    <div class="title">
      门票信息
    </div>
    <div class="tickets-info">
        <div class="tickets-tit">
          票种
        </div>
        <div class="tickets-name">
          <span>{{ticket.ticketName}}</span><span>￥{{ticket.ticketPrice || 0}}</span>
        </div>
    </div>
    <div class="tickets-info">
        <div class="tickets-tit">
          特殊优惠
        </div>
        <div class="tickets-name">
          <span>{{ticket.specialName}}</span><span>-￥{{ticket.specialPrice || 0}}</span>
        </div>
    </div>
    <div class="tickets-info">
        <div class="tickets-tit">
          优惠
        </div>
        <div class="tickets-name">
          <span>早鸟优惠</span><span>-￥{{ticket.datePrice || 0}}</span>
        </div>
    </div>
    <div class="total">
      <span>总计</span><span class="total-price">￥{{ticket.amount || 0}}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ticketsInfo: {
        ticketsName: '医院单位',
        originPrice: 1200,
        SpecialDiscount: '分会委员及会员单位',
        SpecialOffer: 300,
        favourable:'早鸟优惠',
        discount: 200,
      }
    }
  },
  props:['ticket'],
  computed:{
    totalPrice () {
      return this.ticket.ticketPrice - this.ticket.datePrice - this.ticket.specialPrice
      
    }
  }
}
</script>
<style lang="stylus" scoped>
  .tickets
      padding 35px 22px 27px
      background #ffffff
      .title
          color #333333
          font-size 32px
          padding-bottom 29px
  .tickets-info
      padding 12px 0 15px
      border-top 1px dashed rgba(199,199,199,1)
  .tickets-tit
      font-size 30px
      colot #333
      margin-bottom 10px
  .tickets-name
      font-size 24px
      display flex
      justify-content space-between       
  .total
      display flex
      justify-content space-between
      font-size 32px
      color #333
      padding-top 20px
      border-top 1px dashed rgba(199,199,199,1)
      .total-price
          color: #FF4E00
          font-size 28px
  @media screen and (min-width: 800px)
        .tickets
            padding 22px 30px 30px
            background #ffffff
            border 1px solid #989898
            border-radius 7px
            .title
                color #333333
                font-size 20px
                padding-bottom 20px
                display flex
                justify-content center
        .tickets-info
            padding 10px 0 10px
            border-top 1px dashed rgba(199,199,199,1)
            display flex
            align-items center
        .tickets-tit
            width 350px
            font-size 20px
            font-weight 600
            colot #333
            margin-bottom 10px
        .tickets-name
            font-size 20px
            flex 1
            display flex
            justify-content space-between       
        .total
            display flex
            justify-content space-between
            font-size 25px
            color #333
            padding-top 20px
            border-top 1px dashed rgba(199,199,199,1)
            .total-price
                color: #FF4E00
                font-size 28px
</style>
